import { Observable, of } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

/**
 * The help widget shows only in the Whitfields build, for a signed-in user. Display only:
 * `feedback-submit` enforces the staff check.
 */
export function staffAssistantVisible(product: string, authState: Observable<unknown>): Observable<boolean> {
	if (product !== 'whitfields') return of(false);
	return authState.pipe(
		map(user => Boolean(user)),
		distinctUntilChanged()
	);
}
